<template>
  <div :class="$style.container"  @keydown.enter="handleSubmit('pwd')">
    <Form :model="form" label-position="left" :label-width="0" class="pwdLogin" ref="pwd" :rules="rules">
        <FormItem prop="phone">
          <Input v-model="form.phone" placeholder="输入用户名/手机号/邮箱"/>
        </FormItem>
        <FormItem prop="password">
          <Input v-model="form.password" type="password" placeholder="输入登录密码"/>
        </FormItem>
        <FormItem :class="$style.tip">
          <Checkbox v-model="single">记住密码</Checkbox>
          <router-link :to="{path: '/registration/touristPaswd'}" :class="$style.forgetPwd">忘记密码？</router-link>
        </FormItem>
        <FormItem style="margin-top:20px;">
          <Button type="primary" @click.stop="handleSubmit('pwd')">登录</Button>
        </FormItem>
        <FormItem :class="$style.entry" style="margin-top:20px;">
          <router-link :to="{path: '/registration/tourist'}" :class="$style.register">用户注册</router-link>
          <span :class="$style.messageLogin" @click.stop="changeMessageLogin">短信登录</span>
        </FormItem>
    </Form>
  </div>
</template>
<script>
export default {
  props: {
    isSelect: {
      type:Boolean,
      default: false
    }
  },
  data() {
    return {
      form:{
        phone:'',
        password: ''
      },
      single: false,
      rules: {
        phone: [{ required: true, message: "手机号不能为空", trigger: "blur" }],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }]
      }
    };
  },
  watch: {
    isSelect: {
      handler (newValue) {
        this.single = newValue
        if (newValue) {
          let obj = JSON.parse(sessionStorage.getItem("userInfo")) || {}
          this.form.phone = obj.usid
          this.form.password = obj.pwd
        }
      },
      immediate:true
    }
  },
  methods: {
    // 登录、注册
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('login',{account:this.form.phone,password: this.form.password,isSelect: this.single},'02')
        } else {
         return false
        }
      })
    },
    // 切换到手机验证码登录 
    changeMessageLogin () {
      this.$emit('messageLogin')
    },
    // 重置表单
    resetForm () {
      this.form ={
        phone:'',
        password: ''
      }
    }
  }
};
</script> 
<style lang="less" module>
.container {
  form {
    width: 300px;
    margin: 0 auto;
  }
  input {
    width:100%;
    border: none;
    border-bottom: 1px solid #B4CAF7;
    font-size:14px;
  }
  button {
    width: 100%;
    height: 40px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    background: #4B7FF0;
  }
  .tip {
    margin-top: 20px!important;
    &:after {
      display: block;
      content: ' ';
      overflow: hidden;
      clear: both;
    }
    .forgetPwd {
      float:right;
    }
  }
  .entry {
    &:after {
      display: block;
      content: ' ';
      overflow: hidden;
      clear: both;
    }
    .register {
      margin-left: 54px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #999999;
    }
    .messageLogin {
      float:right;
      margin-right:54px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #999999;
      cursor: pointer;
    }
  }
 
}
</style>

<style scoped>
  .pwdLogin >>> .ivu-form-item {
    margin-top: 30px;
    margin-bottom: 0px;
  }
  .pwdLogin >>> .ivu-input:hover, .pwdLogin >>> .ivu-input:focus {
    border-color: #B4CAF7;
    border-bottom: 1px solid #B4CAF7;
    box-shadow:none;
  }
  .pwdLogin >>> .ivu-form-item-error .ivu-input {
    border:none;
    border-bottom: 1px solid #B4CAF7;
  }
</style>